// src/i18n.js
import { createI18n } from 'vue-i18n';
import en from './locales/en';
import axios from 'axios';

const messages = {
  en
};

const urlParams = new URLSearchParams(window.location.search);
const urlLocale = urlParams.get('lang');

const defaultLocale = urlLocale ||
  localStorage.getItem('preferredLanguage') ||
  window.easychatrooms.lang ||
  'en';

const loadLocaleMessages = async (locale) => {
  if (!messages[locale]) { 
    try {
      const response = await axios.get(`https://cdn1.easychatrooms.com/locales/${locale}.json`);
      messages[locale] = response.data;
    } catch (error) {
      console.error(`Could not load messages for locale ${locale}:`, error);
    }
  } else {
    console.log(`Locale ${locale} is already loaded.`);
  }
};

 const setLocale = async (i18n, locale) => {
  if (locale !== i18n.locale) {
    await loadLocaleMessages(locale);
    i18n.locale = locale;
    localStorage.setItem('preferredLanguage', locale);
  }
};

const initLocale = async () => {
  await loadLocaleMessages(defaultLocale);
  const i18n = createI18n({
    locale: defaultLocale,
    fallbackLocale: 'en',
    messages,
  });
  localStorage.setItem('preferredLanguage', defaultLocale);

  return i18n;
};

export { initLocale, setLocale };
